import { COMPANIES, OPPORTUNITIES, SALESORDERS, ACTIVITIES } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';
import Context from 'managers/Context';

export const translateFollowingItemForBackend = (filters, entity) => {
    // In filters, followingItem has to be send to backend as followingStatus.
    // This happens because previously was a boolean filter, but when it became a
    // valuelist filter, backend made a new filter called followingStatus to keep the
    // retro compatibility in mobility.
    // In the webapp we always work with followingItem, but when we have to send it to backend
    // we call it followingStatus.

    const newFilters = { ...filters };

    switch (entity) {
        case ACTIVITIES:
            if (newFilters.FollowingItem) {
                newFilters.followingStatus = newFilters.FollowingItem;
                delete newFilters.FollowingItem;
            }
            if (newFilters.pendingConversations) {
                newFilters.pendingConversationsStatus = newFilters.pendingConversations;
                delete newFilters.pendingConversations;
            }
        case COMPANIES:
        case OPPORTUNITIES:
        case SALESORDERS:
            if (newFilters.followingItem) {
                newFilters.followingStatus = newFilters.followingItem;
                delete newFilters.followingItem;
            }
    }

    return newFilters;
};

export const translateFollowingItemForWeb = (filters, entity) => {
    // We need to translate the old followingItem to the new followingItem
    // The old one was a toggle and was true or not defined
    // The new one is a valuelist that can be 1, 2 or not defined.
    // So we need to translate it for those users that had the filter active (true)
    // during the implementamentation of the new filter as valuelist

    const newFilters = { ...filters };

    switch (entity) {
        case ACTIVITIES:
            if (newFilters.FollowingItem && typeof newFilters.FollowingItem.value === 'boolean') {
                newFilters.FollowingItem.value = '1';
                newFilters.FollowingItem.completeValues = {
                    label: getLiteral('label_following'),
                    value: '1',
                };
                newFilters.followingStatus = newFilters.FollowingItem;
                delete newFilters.FollowingItem;
            }
            if (
                newFilters.pendingConversations &&
                typeof newFilters.pendingConversations.value === 'boolean'
            ) {
                newFilters.pendingConversationsStatus = newFilters.pendingConversations;
                delete newFilters.pendingConversations;
            }

        case COMPANIES:
        case OPPORTUNITIES:
        case SALESORDERS:
            if (newFilters.followingItem && typeof newFilters.followingItem.value === 'boolean') {
                newFilters.followingItem.value = '1';
                newFilters.followingItem.completeValues = {
                    label: getLiteral('label_following'),
                    value: '1',
                };
                newFilters.followingStatus = newFilters.followingItem;
                delete newFilters.followingItem;
            }
    }

    return newFilters;
};

export const translateExtraBoolean = (filter, entity) => {
    // We need to translate the boolean legacy filters values.
    // The old one was a toggle and was true or not defined
    // The new one is a valuelist that can be 1, 2 or not defined.
    // So we need to translate it for those users that had the filter active (true)
    // during the implementamentation of the new filter as valuelist
    // It could be deleted after a prudential time

    if (!entity) return filter;
    const state = Context.store.getState();

    const extraFieldsSchemaMap =
        state?.config?.extraFieldsSchemaMap?.[entity.extraFieldName] || null;

    if (!extraFieldsSchemaMap) return filter;

    let newFilter = { ...filter };

    if (
        extraFieldsSchemaMap[newFilter.id] &&
        typeof newFilter.value === 'boolean' &&
        newFilter.value === true
    ) {
        newFilter.value = '1';
        newFilter.completeValues = {
            label: getLiteral('common_yes'),
            value: '1',
        };
    }

    return newFilter;
};
